import React, { useEffect, useState, useRef } from 'react';
import Cookies from 'js-cookie'
import { useMutation } from 'react-query';
import { useNavigate, useLocation } from 'react-router-dom';

import styles from "./Login.module.css";

import { useClientId } from '../../context/context.js';
import { useLogin } from '../../hooks/useLogin.js';
  
  const Login = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const clientId = useClientId();
    const { loginRequest } = useLogin();
    const [password, setPassword] = useState("")
    const [errorMessage, setErrorMessage] = useState("");
    
    const passwordRef = useRef(null); // create a ref

    const from = location.state?.from?.pathname || `/${clientId}/admin/bookings`;

    useEffect(() => {
      if (passwordRef.current) {
        passwordRef.current.focus(); // set focus when component mounts
      }
    }, []);



    const { mutateAsync: login, isLoading: loginIsLoading } = useMutation({
        mutationFn: loginRequest,
        onSuccess: (result) => {
          if (result?.match && result?.token) {
            Cookies.set(`${clientId}_token`, result.token, {
              secure: process.env.NODE_ENV === "production",
              sameSite: 'Lax',   // prevents CSRF in most cases
          });
          } else {
            setErrorMessage("Password is incorrect.");
          }
        },
        onError: (err) => {
          console.error("Login failed:", err);
          if (err?.response?.status === 401) {
            setErrorMessage("Password is incorrect.");
          } else {
            setErrorMessage("Authentication failed. Please try again.");
          }
        }
    });
  
  
    const handleLogin = async (e) => {
      e.preventDefault();
      setErrorMessage("");
      try {
        const result = await login({ password });
        if (result?.match && result?.token) {
          navigate(from, { replace: true });
        }
      } catch (error) {
        // Error text is set by the mutation handler.
      }
    };

    
    
    return (
      <div className={styles.content}>
        <div>Sign In</div>
        <form id="signin-form">
            <input ref={passwordRef} type="password" 
              id={`password-${clientId}`} name={`password-${clientId}`} placeholder="Password" onChange={(e) => {setPassword(e.target.value)}}  required />
            <button className='btn btn-primary' onClick={(e) => handleLogin(e)}>{loginIsLoading ? "Loading..." : "Sign In"}</button>
            <p>{errorMessage}</p>
        </form>
      </div>
    );
  };
  
  export default Login;
  
